import React, { useState, useEffect } from 'react';
import './Sound.css'; // Подключение стилей




function Sound({ setIsPlaying }) {


    const [currentSong, setCurrentSong] = useState(null);
    const [isPlayerVisible, setIsPlayerVisible] = useState(false);
    const [isPlayerMinimized, setIsPlayerMinimized] = useState(false);



    const songs = [
        { title: 'Моя старость', album: 'Сингл', src: 'Sound/Моя старость.mp3', cover: 'https://avatars.yandex.net/get-music-content/9837520/a6f7509a.a.31581093-1/400x400' },
        { title: 'Приснись', album: 'Сингл', src: 'Sound/Приснись.mp3', cover: 'https://avatars.yandex.net/get-music-content/14715139/e9f299dd.a.34118333-1/400x400' },
        { title: 'Дети', album: 'Сингл', src: 'Sound/Дети.mp3', cover: 'https://avatars.yandex.net/get-music-content/5696151/7818caab.a.20423928-1/m1000x1000' },
    ];




    const playSong = (song) => {
        setCurrentSong(song);
        setIsPlayerVisible(true);
        setIsPlayerMinimized(true); // Плеер сразу свернут
        setIsPlaying(true); // Обновляем состояние в родительском компоненте
        console.log('Music started');
    };

    const closePlayer = () => {
        setIsPlayerVisible(false);
        setIsPlaying(false);
    };

    const toggleMinimizePlayer = () => {
        setIsPlayerMinimized(!isPlayerMinimized);
    };


    const handleAudioPlay = () => {
        setIsPlaying(true); // Включаем светомузыку
    };

    const handleAudioPause = () => {
        setIsPlaying(false); // Останавливаем светомузыку
    };
    useEffect(() => {
        if (isPlayerMinimized && currentSong) {
            const songIndex = songs.findIndex(song => song === currentSong);
            const songListElement = document.querySelector('.minimized-player .song-list');
            if (songListElement) {
                const songElement = songListElement.children[songIndex];
                if (songElement) {
                    songElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }
        }
    });


    //код управления стрелками вперёд назад дял плеера
    const playPreviousSong = () => {
        const currentIndex = songs.findIndex(song => song.src === currentSong.src);
        if (currentIndex > 0) {
            setCurrentSong(songs[currentIndex - 1]);
        } else {
            setCurrentSong(songs[songs.length - 1]);
        }
    };

    const playNextSong = () => {
        const currentIndex = songs.findIndex(song => song.src === currentSong.src);
        if (currentIndex < songs.length - 1) {
            setCurrentSong(songs[currentIndex + 1]);
        } else {
            setCurrentSong(songs[0]);
        }
    };

    return (
        <div className="App">


            <div className="songs-container">
                {songs.map((song, index) => (
                    <div key={index} className="song-card">
                        <img src={song.cover} alt={`Cover for ${song.title}`} />
                        <div className="song-info">
                            <h3>{song.title}</h3>
                            <p>{song.album}</p>
                            <button onClick={() => playSong(song)}>Play</button>
                        </div>
                    </div>
                ))}
            </div>
            <div className="more-music">
                <p>Хотите услышать больше? Присоединяйтесь к нам на этих музыкальных платформах:</p>
                <div className="music-platforms">
                    <a href="https://music.yandex.ru/artist/15607009" target="_blank" rel="noopener noreferrer" className="platform-btn yandex-music">Yandex Music</a>
                    <a href="https://vk.com/artist/mintskoplenok" target="_blank" rel="noopener noreferrer" className="platform-btn vk-music">VK Music</a>
                    <a href="https://open.spotify.com/artist/6lX0B42kpel8bL2jvb3pVU" target="_blank" rel="noopener noreferrer" className="platform-btn spotify">Spotify</a>
                    <a href="https://music.apple.com/us/artist/mintskoplenok/1603423375" target="_blank" rel="noopener noreferrer" className="platform-btn apple-music">Apple Music</a>
                </div>
            </div>


            {isPlayerVisible && (

                <>  <div className={`player-overlay ${isPlayerMinimized ? 'minimized' : ''}`}>

                    <div className="player-container">
                        <h4 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '30px' }}>Песня - {currentSong.title}</h4>
                        <audio controls autoPlay src={currentSong.src}
                            playsInline
                            onPlay={handleAudioPlay} // При воспроизведении включаем анимацию
                            onPause={handleAudioPause} // При паузе выключаем анимацию
                            onEnded={handleAudioPause} // Когда песня заканчивается, тоже выключаем  
                        >

                        </audio>

                        <div className="player-controls" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
                            <button className="player-button previous" onClick={playPreviousSong}></button>
                            <button className="player-button next" onClick={playNextSong}></button>
                            <button className="player-button expand" onClick={toggleMinimizePlayer}></button>
                            <button className="player-button close" onClick={closePlayer}></button>
                        </div>
                    </div>
                </div>
                </>
            )}

        </div>
    );
};

export default Sound;